import Swiper, { Navigation, Pagination } from 'swiper';

declare var ShoppingBasketParms: any;

function waitForElm(selector: string) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

export function initBasketPanelSwiper() {
    const basketalsobought = new Swiper('.swiper.basket-alsobought', {
        modules: [Navigation, Pagination],
        direction: 'horizontal',
        cssMode: true,
        slidesPerView: 3.5,
        slidesPerGroup: 3,
        spaceBetween: 8,
        loop: false,
        speed: 600,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
        },
        breakpoints: {
            500: {
                cssMode: false,
                slidesPerView: 4.5,
                slidesPerGroup: 4,
            },
        },
    });
}


